module.exports = __webpack_public_path__ + "img/edit.0fcd0871.svg";